module.exports = __webpack_public_path__ + "img/ch.269ddab4.svg";